import React from "react";
import { MDBRow, MDBCol } from 'mdb-react-ui-kit';

export default function InfoIniziali({
    setFrom_name,
    setFrom_surname,
    setIndirizzo,
    setCittà,
    setFrom_mail,
    setPhone,
    subject
    }) {

	return (
		<>
            <MDBRow>
                <MDBCol>
                <div className="field">
                    <label className='customLab' for="from_name">Nome *</label>
                    <input type="text" placeholder="Nome" name="from_name" id="from_name" onChange={e => setFrom_name(e.target.value)} />
                </div>
                </MDBCol>
                <MDBCol>
                <div className="field">
                    <label className='customLab' >Cognome *</label>
                    <input type="text" placeholder="Cognome" name="from_surname" id="from_surname" onChange={e => setFrom_surname(e.target.value)} />
                </div>
                </MDBCol>
            </MDBRow>

            <MDBRow>
                <MDBCol>
                <div className="field">
                    <label className='customLab' for="from_name">Indirizzo</label>
                    <input type="address" placeholder="Indirizzo" name="address" id="address" onChange={e => setIndirizzo(e.target.value)} />
                </div>
                </MDBCol>
                <MDBCol>
                <div className="field">
                    <label className='customLab' >Città</label>
                    <input type="city" placeholder="Città" name="city" id="city" onChange={e => setCittà(e.target.value)} />
                </div>
                </MDBCol>
            </MDBRow>

            <MDBRow>
                <MDBCol>
                <div className="field">
                    <label className='customLab' for="from_name">Email *</label>
                    <input type="email" placeholder="Email" name="from_mail" id="from_mail" onChange={e => setFrom_mail(e.target.value)} />
                </div>
                </MDBCol>
                <MDBCol>
                <div className="field">
                    <label className='customLab' >Telefono *</label>
                    <input type="tel" placeholder="Telefono" name="phone" id="phone" onChange={e => setPhone(e.target.value)} />
                </div>
                </MDBCol>
            </MDBRow>

            {/* <MDBRow>
                <div className="field">
                    <label className='customLab' >Oggetto: {subject}</label>
                </div>
            </MDBRow> */}
        </>
	);
}